// This callback runs before every route change, including on page load.
export default function setAppTitle (vue, router) {
  router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = 'Culturial - ' + nearestWithTitle.meta.title

    next()
  })
}
